"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.styles = void 0;
const styles = ({ palette, components }) => ({
    dialogRoot: {
        minWidth: 650,
        padding: 30,
        paddingTop: 10,
        minHeight: 500,
        height: 'calc(100% - 96px)', // from MUI, ensures a full height dialog always
    },
    header: {
        padding: '15px 0px 15px 0px',
    },
    title: {
        marginBottom: 10,
    },
    budgetSummary: {
        borderBottomStyle: 'solid',
        borderBottomColor: palette.border.dark,
        borderBottomWidth: 1,
        borderTopStyle: 'solid',
        borderTopColor: palette.border.dark,
        borderTopWidth: 1,
        padding: '15px 5px 15px 5px',
    },
    summaryHeader: {
        flex: 1.5,
        marginTop: 'auto',
        marginBottom: 'auto',
        fontWeight: 500,
    },
    summaryItem: {
        flex: 1,
    },
    summaryItemHeader: {
        color: palette.text.tertiary,
    },
    summaryItemBody: {
        fontWeight: 600,
        '&.positive': {
            color: palette.amount.positive,
        },
        '&.negative': {
            color: palette.amount.negative,
        },
    },
    addCategoryBlock: {
        borderBottomStyle: 'solid',
        borderBottomColor: palette.border.dark,
        borderBottomWidth: 1,
        padding: 10,
        marginBottom: 16,
    },
    addCategoryButton: {
        marginRight: 10,
    },
    addButtonPrimary: {
        background: palette.action.selected,
        color: palette.primary.dark,
        '&:hover': {
            color: palette.primary.contrastText,
        },
    },
    addButtonSecondary: {
        color: palette.primary.dark,
        '&:hover': {
            color: palette.primary.contrastText,
        },
        background: palette.action.selected,
    },
    qCard: {
        zIndex: 5000,
    },
});
exports.styles = styles;
